import API from 'util/API';

// Admin only: restaurants with an Adyen balance account, as [{ restaurantId, name, balanceAccountId }].
export const getAdyenMerchants = async () => {
  const response = await API.get('/admin/adyenMerchants');
  return (response.data && response.data.merchants) || [];
};

// Admin only: one merchant's statement read live from Adyen; dates are whole Sydney days, YYYY-MM-DD.
export const getAdyenMerchantStatement = async (restaurantId, startDateStr, endDateStr) => {
  const response = await API.get('/admin/adyenMerchantStatement', {
    params: { restaurantId, startDateStr, endDateStr },
    timeout: 60000,
  });
  return response.data;
};
